import { datadogRum } from '@datadog/browser-rum';

export default datadogRum;
